module.exports = __webpack_public_path__ + "img/mid_6.cb42015d.png";